<template>
<span>
<pazar-forushgahi-hero></pazar-forushgahi-hero>
<pazar-forushgahi-details></pazar-forushgahi-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import PageFooter from '@/components/PageFooter';
import PazarForushgahiHero from '@/components/PazarForushgahiHero';
import PazarForushgahiDetails from '@/components/PazarForushgahiDetails';
export default {
    name :'pazarforushgahi',
    components:{
     PazarForushgahiHero,
     PazarForushgahiDetails,
        PageFooter
    }

    
};
</script>


